export default {
  requests: [],
  loadingRequests: false,
  files: [],
  loadingFiles: false,
  uploads: null,
  patient: null,
  provider: null,
  request: null,
  file: null,
  recordTypes: null,
  patientSearchResults: null,
  userSearchResults: null,
  providerSearchResults: null,
  totalItems: null,
  pagination: null,
  groups: null,
  groupsPageInfo: null,
  requestProviderOverrides: null,
  requestsPageInfo: null,
  patientRequests: null,
  documentProvider: null
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/state.js